var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#5A5AF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2475 14.4975C11.0575 14.4975 10.8675 14.4275 10.7175 14.2775L9.2175 12.7775C8.9275 12.4875 8.9275 12.0075 9.2175 11.7175C9.5075 11.4275 9.9875 11.4275 10.2775 11.7175L11.2475 12.6875L14.7175 9.2175C15.0075 8.9275 15.4875 8.9275 15.7775 9.2175C16.0675 9.5075 16.0675 9.9875 15.7775 10.2775L11.7775 14.2775C11.6375 14.4275 11.4375 14.4975 11.2475 14.4975Z",
    fill: "#5A5AF2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.ed5a901e7f1e703d8282fd0243a66c58.svg";
export { ForwardRef as ReactComponent };